import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccueilComponent } from './pages/accueil/accueil.component';
import { AdminComponent } from './pages/admin/admin.component';
import { ImportComponent } from './pages/import/import.component';
import { TableComponent } from './pages/table/table.component';
import { TableSonsComponent } from './pages/table/tableSons.component';
import { EditWinmediaComponent } from './pages/edit/winmedia/editWinmedia.component';
import { EditPreselectMonthlyPlaylistComponent } from './pages/edit/preselectMonthlyPlaylist/editPreselectMonthlyPlaylist.component';
import { EditPreselectCategoryComponent } from './pages/edit/preselectCategory/editPreselectCategory.component';
import { SpotsComponent } from './pages/spots/spots.component';
import { SpotsProgComponent } from './pages/spots/spotsProg.component';

const routes: Routes = [
  { path: '', redirectTo: 'accueil', pathMatch: 'full' },
  { path: 'accueil', component: AccueilComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'import', component: ImportComponent },
  { path: 'table', component: TableComponent },
  { path: 'tableSons', component: TableSonsComponent },
  { path: 'editWinmedia', component: EditWinmediaComponent },
  { path: 'editPreselectMonthlyPlaylist', component: EditPreselectMonthlyPlaylistComponent },
  { path: 'editPreselectCategory', component: EditPreselectCategoryComponent },
  { path: 'spots', component: SpotsComponent },
  { path: 'spotsProg', component: SpotsProgComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
